import { useEffect, useState } from "react";
import { backend_url } from "../../App";
import AddReview from "./AddReview";
import AllReviewsPopup from "./AllReviewsPopup";

const Reviews = ({ productId }) => {
  const [reviews, setReviews] = useState([]);
  const [showAddPopup, setShowAddPopup] = useState(false);
  const [showAllPopup, setShowAllPopup] = useState(false);

  useEffect(() => {
    fetch(`${backend_url}/api/customerreview`)
      .then((res) => res.json())
      .then((data) => {
        const filteredReviews = data.filter(
          (review) => review.productId === productId && review.showHide === true
        );
        setReviews(filteredReviews);
      })
      .catch((err) => console.error("Failed to load reviews", err));
  }, [productId]);

  return (
    <div className="w-[90%] mx-auto px-4 py-12">
      <h2
        className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-medium text-center mb-6"
        style={{ fontFamily: "'Times New Roman', Serif" }}
      >
        What Our Customers Say
      </h2>

      <div className="flex justify-center mb-10">
        <hr className="w-3/4 md:w-1/2 h-1 bg-black rounded-xl" />
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-center gap-3 mb-6">
        <button
          onClick={() => setShowAddPopup(true)}
          className="bg-[#945bd1] hover:bg-[#623394] text-white px-4 py-2 rounded-lg"
        >
          Write a Review
        </button>

        {reviews.length > 4 && (
          <button
            onClick={() => setShowAllPopup(true)}
            className="text-purple-700 underline hover:text-purple-900"
          >
            View All Reviews
          </button>
        )}
      </div>

      {reviews.length === 0 ? (
        <div className="text-center mt-10">
          <p className="text-gray-500 text-lg">No reviews yet.</p>
          <p className="text-purple-600 font-semibold">
            Be the first to write a review!
          </p>
        </div>
      ) : (
        <div className="flex flex-wrap gap-4 justify-center mt-8">
          {reviews.slice(0, 4).map((review) => (
            <div
              key={review._id}
              className="w-full sm:w-[48%] md:w-[48%] lg:w-[23%] border p-4 rounded-lg shadow-md relative pb-7 bg-white"
            >
              <h3 className="font-bold text-lg text-purple-600">
                {review.reviewTitle.charAt(0).toUpperCase() +   review.reviewTitle.slice(1)}
              </h3>
              <p className="text-gray-600 mt-1 first-letter:uppercase">
                {review.review.charAt(0).toUpperCase() +   review.review.slice(1)}
              </p>
              <div className="flex items-center space-x-1 text-yellow-400 mt-2">
                {Array.from({ length: review.rating }, (_, i) => (
                  <span key={i}>⭐</span>
                ))}
              </div>

              {review.reviewImage && (
                <img
                  crossOrigin="anonymous"
                  src={review.reviewImage}
                  alt="Review"
                  className="mt-3 rounded-md object-cover w-full h-auto max-h-48"
                />
              )}
              <p className="text-purple-500 text-sm absolute bottom-2">
                By: {review.name.charAt(0).toUpperCase() +   review.name.slice(1)}
              </p>
            </div>
          ))}
        </div>
      )}

      {showAddPopup && (
        <AddReview
          onClose={() => setShowAddPopup(false)}
          productId={productId}
        />
      )}
      {showAllPopup && (
        <AllReviewsPopup
          reviews={reviews}
          onClose={() => setShowAllPopup(false)}
        />
      )}
    </div>
  );
};

export default Reviews;
